export * from './DictionaryText'
